import { Entity } from "../../Entity";
import EmailAccountFactory from "../../Factories/EmailAccountFactory";
import { EmailAccountInterface } from "./EmailAccountInterface";
import { FactoryInterface } from "../../FactoryInterface";
import { PersonInterface } from "../Person/PersonInterface";
import { CompanyInterface } from "../Company/CompanyInterface";
import { SubscriptionInterface } from "../Subscription/SubscriptionInterface";
import SubscriptionTypeContainer from "../../../Entity/Entities/Subscription/SubscriptionType/SubscriptionTypeContainer"
import Store from "../../../Store/Store";

class EmailAccount extends Entity implements EmailAccountInterface {


  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return EmailAccountFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get agencyId(): number {
    return this.data.agencyId;
  }

  get agency(): CompanyInterface {
    const agency: CompanyInterface = Store.getConfigurator().getState()?.app?.companies?.find((company: CompanyInterface) => company?.isAgency);
    
    return agency;
  }

  get personId(): number {
    return this.data.personId;
  }

  get person(): PersonInterface | any {
    if (this.isAgencyAccount() === true) {
      throw new Error("Email accounts connected to an Agency does not have Person property.");
    }

    return this.relation("app.persons", this.data.personId)[0];
  }

  get imapUser(): string {
    return this.data.imapUser;
  }

  get imapPassword(): string {
    return this.data.imapPassword;
  }

  get imapHost(): string {
    return this.data.imapHost;
  }

  get imapPort(): number {
    return this.data.imapPort;
  }

  get imapTls(): boolean {
    return this.data.imapTls;
  }

  get lastTimeParsed(): string {
    return this.data.lastTimeParsed;
  }

  get active(): boolean {
    return this.data.active;
  }

  get valid(): boolean {
    return this.data.valid;
  }

  get reason(): string {
    return this.data.reason;
  }

  get subscription(): SubscriptionInterface {
    return this.subscriptionRelation(SubscriptionTypeContainer.pickIdFromLabel("Email_accounts"), this.data.id);
  }

  get isSubscribed(): boolean {
    return this.subscription !== null;
  }

  get providerId(): number {
    return this.data.providerId;
  }

  public isAgencyAccount(): boolean {
    return this.data.personId === null;
  }

  public renderPrioritizedAvatar(): any {
    // If we have relation to a user, then we belong to a user. Agency relation is secondary
    if (this.isAgencyAccount() === false) {
      return this.person.renderAvatar();
    }

    return this.agency.renderAvatar();
  }
}

export { EmailAccount }
